export function Divider({ className = '' }) {
  return <div className={`h-[1px] w-full bg-[#424448] ${className}`} />
}
